const currencyFormatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const percentFormatter = new Intl.NumberFormat('en-GB', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const dateFormatter = new Intl.DateTimeFormat('en-GB');

const valueFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  signDisplay: 'negative',
});

const ratioFormatter = new Intl.NumberFormat('en-GB', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatCurrency = (value: number): string => {
  if (typeof value !== 'number' || isNaN(value)) {
    return '';
  }

  try {
    return currencyFormatter.format(value);
  } catch (error) {
    console.error('Error formatting currency:', error);
    return value.toString();
  }
};

export const formatPercentage = (value: number): string => {
  if (typeof value !== 'number' || isNaN(value)) {
    return '';
  }

  try {
    return percentFormatter.format(value / 100);
  } catch (error) {
    console.error('Error formatting percentage:', error);
    return value.toString();
  }
};

export const formatDate = (date: Date | null): string =>
  date ? dateFormatter.format(date) : 'Not set';

export const formatValue = (value: number | null): string => {
  if (value === null || typeof value !== 'number' || isNaN(value)) {
    return '';
  }

  try {
    return valueFormatter.format(value);
  } catch (error) {
    console.error('Error formatting value:', error);
    return value.toString();
  }
};

export const formatRatio = (value: number): string => {
  if (typeof value !== 'number' || isNaN(value)) {
    return '';
  }

  try {
    return ratioFormatter.format(value);
  } catch (error) {
    console.error('Error formatting ratio:', error);
    return value.toString();
  }
};

export const format = {
  currency: formatCurrency,
  percent: formatPercentage,
  date: formatDate,
  value: formatValue,
  ratio: formatRatio,
};

